<app-navbar title="Kwaterunek - generowanie">
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<div class="container mt-4">
	<form class="d-flex flex-column" [formGroup]="formGroup">
		<div>
			<mat-form-field class="me-3" appearance="outline">
				<mat-label>Dla daty</mat-label>
				<input matInput [matDatepicker]="picker" formControlName="forDate" />
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
				@if (formGroup.controls['forDate'].errors?.required) {
					<mat-error>Data jest wymagana</mat-error>
				}
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-select placeholder="Wybierz destynację" formControlName="destination">
					@for (destination of roomingListLocations | keyvalue; track destination.value.id) {
						<mat-option [value]="destination.value">{{ destination.value.name }}</mat-option>
					}
				</mat-select>
				@if (formGroup.controls['destination'].errors?.required) {
					<mat-error>Lokalizacja jest wymagana</mat-error>
				}
			</mat-form-field>
		</div>

		<button class="w-fit" mat-raised-button color="primary" (click)="generateRL()">Generuj Rooming Listę</button>
	</form>
	<hr />

	@for (destination of roomingListLocations | keyvalue; track destination.value.name) {
		<div class="mb-2">
			<a [href]="destination.value.href" target="_blank">
				<i class="fas fa-external-link-alt icon"></i>
				RL {{ destination.value.name }}
			</a>
		</div>
	}
</div>
